exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".new-event-wooba-flight-reservation__inner[data-v-79627a02]{margin-top:60px;margin-bottom:100px}.new-event-wooba-flight-reservation__frame[data-v-79627a02]{display:block;width:100%;min-height:1000px;border:0;overflow:hidden}@media (max-width:600px){.new-event-wooba-flight-reservation__inner[data-v-79627a02]{margin-top:36px;margin-bottom:60px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-79627a02","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/event/WoobaFlightReservation.vue
// module id = 1085
// module chunks = 0